import type { Restrictions } from '@/hooks/useInfiniteCompanyScreenersQuery/queryFn';

export const getIsRestricted = (
  searchRestrictions?: Restrictions | null,
  systemRestrictions?: Restrictions | null
) => {
  return searchRestrictions?.isRestricted || systemRestrictions?.isRestricted;
};

const REASON_MAPPING = {
  PLAN_LIMIT_COMPANY_COUNT: 'New stock alerts disabled due to plan limits',
  USER_IS_GUEST: 'New stock alerts disabled due to plan limits',
} as const;

export const getRestrictionReason = (
  searchRestrictions?: Restrictions | null,
  systemRestrictions?: Restrictions | null
): string => {
  const limitCode =
    (searchRestrictions?.restrictionCode ||
      systemRestrictions?.restrictionCode) ??
    '';
  return (
    REASON_MAPPING[limitCode] ||
    searchRestrictions?.restrictionReason ||
    systemRestrictions?.restrictionReason
  );
};

export const checkUsingPredefinedUserQuery = (
  gridViewId?: number,
  isRulesDirty?: boolean
) => {
  const isUserPredefinedScreener = !!gridViewId && !Number.isNaN(gridViewId);
  return isUserPredefinedScreener && !isRulesDirty;
};
